<template>
  <modal ref="modal">
    <template #header>
      <h5 class="modal-title mt-0">{{ $t('records_list.link_to_share')}}</h5>
    </template>

    <template #body>
      <form @submit.prevent='shareRecord'>
        <div class="shareable-link-wrapper modal-body">
          <div class="sharing-link-group copy-to-clipboard-wrapper">
            <label>
              {{ $t('share_invite.link_sharing') }}
            </label>
            <input name="record[shared]" type="text" class="public_link form-control" readonly="readonly" :value="shareRecordUrl">
            <a href='#' :class="['btn', 'btn-neutral', 'float-right', {'disabled': !record.shared}]" @click.prevent="copyToClipboard($event, '.public_link')">
              {{ $t('folders.settings.sharing_link_copy') }}
            </a>
            <p>{{ $t('records_list.anyone_can_see') }}</p>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../../_modal'

  export default {
    components: {
      modal: _modal,
    },
    data() {
      return {
        record: {},
      }
    },
    computed: {
      shareRecordUrl() {
        return window.location.origin + this.$router.resolve({ name: 'public_shared_record_show', params: { uuid: this.record.shared_uuid } }).href
      },
    },
    methods: {
      open(record) {
        this.record = Object.assign({}, record)
        this.$refs.modal.open()
      },
      shareRecord(e) {
        this.store.updateRecord(this.record, { shared: !this.record.shared }).then(() => {
          this.store.sendMetrics({name: 'share_file', params: this.$route.params, path: this.$route.fullPath})
          this.$emit('success')
        })
      },
    }
  }
</script>
<style lang="sass" scoped>
  .btn-neutral
    margin: 10px 0
</style>
